import { API } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api';

import { getFirstRow } from 'utils/graphql';
import { listJobCategoryMappings as ListJobCategoryMappings } from 'graphql/queries';
import {
  createJobCategoryMapping as CreateJobCategoryMapping,
  updateJobCategoryMapping as UpdateJobCategoryMapping
} from 'graphql/mutations';
import {
  JobCategoryMapping,
  CreateJobCategoryMappingMutation,
  UpdateJobCategoryMappingMutation
} from 'graphql-api';

async function getJobCategoryMappings(): Promise<JobCategoryMapping | null> {
  return await getFirstRow(ListJobCategoryMappings, 'listJobCategoryMappings');
}

export async function createOrUpdateJobCategoryMapping(
  jobCategoryMappingsParam: Record<string, string>
): Promise<JobCategoryMapping | null> {
  const mapping = await getJobCategoryMappings();
  if (mapping != null) {
    const responseData = (await API.graphql({
      query: UpdateJobCategoryMapping,
      variables: {
        input: {
          id: mapping.id,
          mappingJSON: JSON.stringify({
            ...JSON.parse(mapping.mappingJSON ?? ''),
            ...jobCategoryMappingsParam
          })
        }
      },
      authMode: 'AMAZON_COGNITO_USER_POOLS'
    })) as GraphQLResult<UpdateJobCategoryMappingMutation>;
    return responseData.data?.updateJobCategoryMapping ?? null;
  } else {
    const responseData = (await API.graphql({
      query: CreateJobCategoryMapping,
      variables: {
        input: {
          mappingJSON: JSON.stringify(jobCategoryMappingsParam)
        }
      },
      authMode: 'AMAZON_COGNITO_USER_POOLS'
    })) as GraphQLResult<CreateJobCategoryMappingMutation>;
    return responseData.data?.createJobCategoryMapping ?? null;
  }
}
